import React, { Component } from 'react';
import {
    selectedDateOptionSelector,
    selectedIntervalSelector
} from '../../reports/selectors/reports-selectors';

import Intervalpicker from '../../common/components/intervalpicker';
import PropTypes from 'prop-types';
import { buildIntervalOptions } from '../../utils/intervalpicker-utils';
import { changeInterval } from '../../common/actions/datepicker-action-creators';
import { connect } from 'react-redux';
export class IntervalpickerContainer extends Component{
    handleIntervalChange = ( interval ) => {
        const { changeInterval, namespace } = this.props;
        changeInterval( {
            interval,
            namespace,
        } );
    }

    render(){
        const {
            namespace,
            selectedInterval,
            selectedDateOption } = this.props;
        const opts = buildIntervalOptions( selectedDateOption );
        return (
            <Intervalpicker
                automationId={`intervalpicker-${namespace}`}
                selectedInterval={selectedInterval}
                handleIntervalChange={this.handleIntervalChange}
                intervalOptions={opts}
            />
        );
    }
};

/* istanbul ignore next */
const mapStateToProps = state => {
    return {
        selectedDateOption: selectedDateOptionSelector( state ),
        selectedInterval: selectedIntervalSelector( state )
    };
};

IntervalpickerContainer.propTypes = {
    changeInterval: PropTypes.func.isRequired,
    namespace: PropTypes.string.isRequired,
    selectedDateOption: PropTypes.string.isRequired,
    selectedInterval: PropTypes.string.isRequired,
};

export default connect( mapStateToProps, { changeInterval } )( IntervalpickerContainer );
